const initialState: string[] = [];

/**
 * importSelectedClassesReducer: Stores class names selected in Step 2
 * so Step 3 (TagsAndNames) can render one row per class.
 *
 * State shape: string[]  e.g. ["Smudge", "Scratch"]
 */
const importSelectedClassesReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case "SET_IMPORT_SELECTED_CLASSES":
            return action?.payload;
        default:
            return state;
    }
};

export default importSelectedClassesReducer;